export default __webpack_public_path__ + "static/media/laval18.e268fb19.jpg";